module.exports = __webpack_public_path__ + "img/enseption_04.99717af6.png";